import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import {
  BASE_PERMISSIONS,
  baseAssignmentsActions,
  baseAssignmentsSelectors,
  BaseCoreState,
  BaseInquiryService,
  BaseOfferStatus,
  BaseRolesService,
  CustomerProfileAssignmentItemResponse,
  RequirementCategoryResponse,
  CustomerOfferType,
} from 'base';

@Component({
  selector: 'base-customer-offer-master-data-tab',
  templateUrl: './base-customer-offer-master-data-tab.component.html',
})
export class BaseCustomerOfferInfoMasterDataTabComponent implements OnChanges, OnInit, OnDestroy {
  @Input() offer: CustomerOfferType | undefined;
  @Input() inquiryRequirementCategories: RequirementCategoryResponse[];
  @Input() isInquiryDetailsPage: boolean = false;
  candidateRequirementCategories: RequirementCategoryResponse[] = [];
  endedAssignments: CustomerProfileAssignmentItemResponse[] = [];
  distanceLabel: string = '';
  hasAdminAssignmentsPermission: boolean;
  offerStatuses = BaseOfferStatus;

  private destroy$ = new Subject<void>();

  constructor(
    private store: Store<BaseCoreState>,
    private inquiryService: BaseInquiryService,
    private rolesService: BaseRolesService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.offer.currentValue) {
      const offer: CustomerOfferType = changes.offer.currentValue;

      this.distanceLabel = offer.distance !== undefined ? `${offer.distance} km` : '';
      this.candidateRequirementCategories = offer.profile?.requirements as RequirementCategoryResponse[];
      if (this.hasAdminAssignmentsPermission) {
        this.store.dispatch(
          baseAssignmentsActions.getCandidateEndedAssignments({ payload: offer.profile?.id as number })
        );
      }
    }
  }

  ngOnInit(): void {
    this.hasAdminAssignmentsPermission = this.rolesService.hasCustomerFeaturePermission(
      BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENTS
    );

    if (this.offer && this.isInquiryDetailsPage && this.hasAdminAssignmentsPermission) {
      this.store.dispatch(
        baseAssignmentsActions.getCandidateEndedAssignments({ payload: this.offer.profile?.id as number })
      );
    }

    this.store
      .select(baseAssignmentsSelectors.getCandidateEndedAssignments)
      .pipe(
        takeUntil(this.destroy$),
        filter((endedAssignmentsState) => endedAssignmentsState.ok === true),
        map((endedAssignmentsState) => endedAssignmentsState.data)
      )
      .subscribe((list) => {
        this.endedAssignments = list;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  hasRequirementInCategories(requirementCategories: RequirementCategoryResponse[], requirementId: number): boolean {
    return this.inquiryService.ungroupRequirements(requirementCategories).some((item) => item.id === requirementId);
  }

  inquiryContainsCategoryRequirements(category: RequirementCategoryResponse): boolean {
    return category.requirements.every((requirement) =>
      this.inquiryService
        .ungroupRequirements(this.inquiryRequirementCategories)
        .some((item) => item.id === requirement.id)
    );
  }
}
